import React, { useState, useEffect } from 'react';
import ReactDatepicker, { registerLocale } from 'react-datepicker';
import { enUS, enGB, fr, es } from 'date-fns/locale';
import styles from './Datepicker.scss';
import 'react-datepicker/dist/react-datepicker.css';

const dateFormatMapping = {
  'en-US': 'MM/dd/yyyy',
  'en-GB': 'dd/MM/yyyy',
  'fr-FR': 'dd/MM/yyyy',
  'es-ES': 'dd/MM/yyyy',
};

registerLocale('en-US', enUS);
registerLocale('en-GB', enGB);
registerLocale('fr-FR', fr);
registerLocale('es-ES', es);

const Datepicker = React.forwardRef((props, ref) => {
  const [locale, setLocale] = useState('en-US');

  useEffect(() => {
    const userLocale = navigator.language || 'en-US';
    setLocale(userLocale);
  }, []);

  return (
    <div className="datepicker-container" id="reservationForm-moveInDate">
      <ReactDatepicker
        dateFormat={dateFormatMapping[locale]}
        className="form-control"
        wrapperClassName={styles.wrapper}
        locale={locale}
        ref={ref}
        {...props}
      />
    </div>
  );
});

const propTypes = {};

const defaultProps = {};

Datepicker.propTypes = propTypes;
Datepicker.defaultProps = defaultProps;

export default Datepicker;
